import EntityClassRequest from '../../model/entity-class-request';
import { initFilterExpression } from '../../model/filterExpressionUtils';

/**
 * @ngdoc component
 * @name mx.SolutionBuilderAgent:mxObjectsLink
 * @module mx.SolutionBuilderAgent
 * @description Displays related object
 * @param {string} label@ - Optional. Label of the control.
 * @param {string} entityClassName@ - SPS class where data should be loaded from.
 * @param {value} object= - Reference to the Entity object
 */

angular.module('mx.SolutionBuilderAgent').component('mxRelatedObjectsLink', {
	require: {
		parentViewController: '?^^mxView',
	},
	bindings: {
		relation: '<value',
		label: '@',
		valueLabel: '@',
		hideOnEmptyValue: '@',
		displayExpression: '@',
		icon: '@',
		columnDefinition: '@',
		valueMinWidth: '@',
		labelPosition: '@?',
		labelMinWidth: '@',
		labelMaxWidth: '@',
		designerMode: '<?',
		valueColor: '@',
		labelColor: '@',
		iconColor: '@',
		mxAtId: '@',
	},
	controller: MxRelatedObjectsLinkCtrl,
	controllerAs: 'vm',
	template: [
		'$attrs',
		function (attrs) {
			const optimizer = typeof attrs.designerMode !== 'undefined' && ('' + attrs.designerMode).toLowerCase() !== 'false' ? '' : '::';

			return `<mx-literal
						label="{{::vm.label}}"
						label-position="{{::vm.labelPosition}}"
						type="links"
						value="${optimizer}vm.value"
						icon="{{::vm.icon}}"
						hide-on-empty-value="{{::vm.hideOnEmptyValue}}"
						value-min-width="{{::vm.valueMinWidth}}"
						label-min-width="{{::vm.labelMinWidth}}"
						label-max-width="{{::vm.labelMaxWidth}}"
						value-color="{{::vm.valueColor}}"
						label-color="{{::vm.labelColor}}"
						icon-color="{{::vm.iconColor}}"
						${typeof attrs.designerMode !== 'undefined' ? `designer-mode="${attrs.designerMode}" ` : ''}>
					</mx-literal>`;
		},
	],
});

MxRelatedObjectsLinkCtrl.$inject = [
	'mx.SolutionBuilderAgent.SchemaService',
	'$q',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'$scope',
	'$attrs',
	'$element',
];

function MxRelatedObjectsLinkCtrl(schemaService, $q, entityService, i18n, dialogOpener, $scope, $attrs, $element) {
	const vm = this;

	vm.$onInit = function () {
		initFilterExpression({
			propertyName: 'filter',
			controlMxAtId: vm.mxAtId,
			$scope,
			$attrs,
			$element,
			controller: vm,
		});
	};

	vm.$postLink = function () {
		vm.archived = vm.parentViewController?.mxView?.context?._archived || false;
		initValue();
	};

	async function getFragments(top) {
		const requestData = new EntityClassRequest(vm.relation.relationsConfig.referenceFrom, vm.filter, top, vm.columnDefinition);

		requestData.allowedTypes = vm.allowedTypes;
		requestData.fragmentId = vm.relation.fragmentId;
		requestData.relationName = vm.relation.relationsConfig.attributeFrom;
		requestData.displayExpression = vm.displayExpression;
		requestData.archived = vm.archived;

		return await entityService.getFragmentDescriptors(requestData);
	}

	function setShowAllValue(count) {
		const obj = {
			text: vm.valueLabel || i18n.get('solutionBuilderAgent.components.mx-objects-literal.objects'),
			onClick: async () => {
				dialogOpener
					.openObjectsListPreview(
						{
							relation: vm.relation,
							filterExpression: vm.filter,
							archived: vm.archived,
							label: vm.valueLabel || i18n.get('solutionBuilderAgent.components.mx-objects-literal.objects'),
							columnDefinition: vm.columnDefinition,
						},
						vm.parentViewController && vm.parentViewController.mxView
					)
					.catch(mx.logCatch);
			},
		};
		if (count) {
			obj.text += `[${count}]`;
		}
		vm.value = [obj];
	}

	async function initValue() {
		if (!(vm.relation instanceof mx.SolutionBuilderAgent.Relation) || vm.relation.Count === 0 || !vm.relation.fragmentId) {
			vm.value = null;
			return;
		}

		const maxVisibleAmount = 4;
		let fragments;

		let objectCount = vm.relation.Count;

		if (vm.filter.hasFilter()) {
			fragments = await getFragments();
			objectCount = fragments.length;
		} else if (typeof objectCount === 'undefined') {
			fragments = await getFragments(maxVisibleAmount);
			if (fragments.length < maxVisibleAmount) {
				objectCount = fragments.length;
			}
		}

		if (objectCount < maxVisibleAmount) {
			fragments = fragments || (await getFragments());
			vm.value = fragments.map((fragment) => ({
				text: fragment.DisplayString,
				onClick: () => dialogOpener.openPreview(fragment, undefined, undefined, vm.parentViewController && vm.parentViewController.mxView),
			}));
		} else {
			setShowAllValue(objectCount);
		}
	}
}
